import React, {useEffect} from 'react'
import '../assets/css/onboard.css'
import { Link } from 'react-router-dom'
import AddWallet from '../components/modals/AddWallet'
import img1 from "../assets/images/screen1.png"
import img2 from "../assets/images/screen2.png"
import img3 from "../assets/images/screen3.png"

const Onboard = () => {
    useEffect(() => {
        document.title = 'Pouch | Connect a wallet'
    }, [])

    return (
        <>            
            <div className="body bg-dark h-100 m-0">
                <div className="d-flex align-items-center justify-content-center">  
                    <div className="p-3 mx-3 m-md-0 shadow-lg bg-dark text-white text-center" style={{borderRadius: '15px', maxWidth: '500px', minWidth: '40%'}}>
                        <div id="carouselExampleIndicators" className="carousel" data-ride="carousel">
                            <ol className="carousel-indicators">
                                <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                            </ol>
                            <div className="carousel-inner">
                                {[
                                    {
                                        id: 1,
                                        active: true,
                                        title: "Easy access",
                                        img: img1
                                    },
                                    {
                                        id: 2,
                                        active: false,
                                        title: "Easy remittance",
                                        img: img3
                                    },
                                    {
                                        id: 3,
                                        active: false,
                                        title: "Private and Secure",
                                        img: img2
                                    }
                                ].map(ele => <Test key={ele.id} img={ele.img} title={ele.title} active={ele.active} id={ele.id} />)}
                            </div>
                        </div>
                        <AddWallet />
                        <button className="button btn btn-purple" type="button" data-toggle="modal" data-target="#modalAddWallet">Connect a new wallet</button>
                        <p className="mb-3 mt-3 text-light">Skip for now? <br /><Link to="/dashboard" className="text-purple">Use the default pouch wallet</Link></p>
                    </div>
                </div>
            </div>
        </>
    )
}

const Test = ({title, active, img}) => {
    return (
        <div className={`carousel-item ${active && 'active'}`}>
            <div className="carousel-caption">
                <h5>{title}</h5>
            </div>
            <img className="d-block m-auto" style={{maxWidth: '250px', minWidth: '100px'}} src={img} alt={title} />
        </div>
    )
}
export default Onboard
